import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { NotificationRepository } from "../../notification/notification.repository";
import { Notification } from "../../notification/notification.model";
import { SafeHtmlPipe } from "../../shared/html/safe-html.pipe";

@Component({
  selector: "app-notification-highlight",
  templateUrl: "./notification-highlight.component.html",
  styleUrls: ["./notification-highlight.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SafeHtmlPipe],
})
export class NotificationHighlightComponent implements OnInit {
  private notificationRepository = inject(NotificationRepository);

  public notifications = [];

  ngOnInit() {
    this.checkNotifications();
  }

  public checkNotifications() {
    this.notificationRepository.getMyHighlights().subscribe((notifications) => {
      this.notifications = notifications;
    });
  }

  public markAsRead(notification: Notification) {
    this.notificationRepository
      .markAsRead(notification)
      .subscribe((removedNotification) => {
        const index = this.notifications.indexOf(notification, 0);
        if (index > -1) {
          this.notifications.splice(index, 1);
        }
      });
  }
}
